"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    option1: {
        twoFromSameLanguageFromSubjectAreas: {
            "foreign language": 2
        }
    },
    option2: {
        requiredCourses: {
            "computer science i": 1,
            "computer science ii": 1,
            "computer science iii": 1
        }
    }
};
//# sourceMappingURL=languageOTE.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/languageOTE.js
// module id = 446
// module chunks = 22